import React from 'react';
import LoadingContent from '~/components/LoadingContent';
import { StyledMain } from './styles';
export const LoadingPage: React.FC = () => {
  return <StyledMain data-sentry-element="StyledMain" data-sentry-component="LoadingPage" data-sentry-source-file="index.tsx">
      <title>Page is Loading</title>
      <LoadingContent data-sentry-element="LoadingContent" data-sentry-source-file="index.tsx" />
    </StyledMain>;
};
export default LoadingPage;